import React from 'react';
import { ClockIcon } from './icons';
import { useAssessmentContent } from './content/context';

const AssessmentSidePanel: React.FC = () => {
  const { sidePanel } = useAssessmentContent();
  const [para1, para2, para3] = sidePanel.paragraphs;

  return (
    <div className="bg-a-navy flex flex-col justify-between" style={{ padding: '56px 48px' }}>
      <div className="flex flex-col justify-center flex-1">
        <h1 className="font-extrabold text-white font-sans mt-0 mb-7" style={{ fontSize: '30px', lineHeight: '1.20' }}>
          {sidePanel.headlineLead} <span className="text-a-orange">{sidePanel.headlineHighlight}</span>
        </h1>

        <div className="flex flex-col mb-0">
          <div className="pt-1 pb-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
            <p
              className="font-light m-0 text-white"
              style={{
                fontSize: '12.5px',
                lineHeight: '1.75',
              }}
            >
              {para1}
            </p>
          </div>
          <div
            style={{
              borderBottom: '1px solid rgba(255,255,255,0.07)',
              padding: '18px 0',
            }}
          >
            <p
              className="font-light m-0 text-white"
              style={{
                fontSize: '12.5px',
                lineHeight: '1.75',
              }}
            >
              <strong className="text-white" style={{ fontWeight: 600 }}>
                {para2}
              </strong>
            </p>
          </div>
          <div className="py-5">
            <p
              className="font-light m-0 text-white"
              style={{
                fontSize: '12.5px',
                lineHeight: '1.75',
              }}
            >
              {para3}
            </p>
          </div>
        </div>

        <div className="mb-7 mt-1">
          <div
            className="font-extrabold text-a-orange uppercase mb-3"
            style={{ fontSize: '11px', letterSpacing: '0.10em' }}
          >
            {sidePanel.youllGetTitle}
          </div>
          <div className="flex flex-col" style={{ gap: '9px' }}>
            {sidePanel.youllGet.map((item) => (
              <div key={item} className="flex items-start text-white" style={{ gap: '10px' }}>
                <div
                  className="rounded-full bg-a-orange flex-shrink-0"
                  style={{ width: '5px', height: '5px', marginTop: '6px' }}
                />
                <span className="text-white" style={{ fontSize: '12px', lineHeight: '1.55' }}>
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 pt-5 border-t" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
        <ClockIcon />
        <span
          style={{
            fontSize: '12px',
            color: 'rgba(255,255,255,0.75)',
            fontWeight: 600,
            letterSpacing: '0.01em',
          }}
        >
          {sidePanel.timeBadge}
        </span>
      </div>
    </div>
  );
};

export default AssessmentSidePanel;
